import React from 'react';
import {ChangelogProvider} from './context/ChangelogContext';
import ChangelogPage from './components/ChangelogPage';
import ChangelogDetail from './components/ChangelogDetail';

const Changelog = () => (
  <ChangelogProvider>
    <ChangelogPage />
  </ChangelogProvider>
);

export const ChangelogDetailPage = () => (
  <ChangelogProvider>
    <ChangelogDetail />
  </ChangelogProvider>
);

export default Changelog;
